export default state => ({
  ...state,
  selection: [],
});
